import countBy from 'lodash/countBy';

import { shopCartFragment$data } from '__generated__/shopCartFragment.graphql';
import { CartCookieSegment } from 'shared/types/cart';

export interface GetSegmentCartItemCountParameter {
  numberOfCartItems: number;
  cartSegment: CartCookieSegment;
  isBusiness: boolean;
}

export interface GetAddCountProps {
  offerId: string;
  selectedBundles: shopCartFragment$data['bundles'];
}

export const getSegmentCartItemCount = ({
  numberOfCartItems,
  cartSegment,
  isBusiness,
}: GetSegmentCartItemCountParameter) => {
  return (isBusiness && cartSegment === 'Business') ||
    (!isBusiness && cartSegment === 'Consumer')
    ? numberOfCartItems
    : 0;
};

export const getAddCount = ({ offerId, selectedBundles }: GetAddCountProps) => {
  const addCounts = countBy(
    selectedBundles?.flatMap((bundle) => bundle.offerIds),
  );
  return addCounts[offerId] || 0;
};
